<template>
  <wp-items-edit
    content-type="news-articles"
    content-type-singular="news-article"
    content-name="News articles"
    content-name-singular="News article"
  />
</template>

<script>
import WpItemsEdit from '@/views/wp-item/wp-items-edit/WpItemsEdit.vue'

export default {
  components: {
    WpItemsEdit,
  },
}
</script>

<style scoped>

</style>
